/****************************************************
 * Module Name:  stoneMediaModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { useState } from "react";
import { Button } from "@mui/material";
import Modal from "react-bootstrap/Modal";
import Constants from "../../utility/constants";
import logo from '../../images/pansuriya.jpg'
import "./../../style/modalstyle.css";
import ShareIcon from '@mui/icons-material/Share';
import CommonSnackbar from "./commonSnackBar";

const StoneMediaModal = ({ stoneMediaURL, handleClose, show }) => {

    const [showSuccessSnackbar, setShowSuccessSnackbar] = useState(false);

    return (
        <>
            <CommonSnackbar
                show={showSuccessSnackbar}
                message={"Link Copied Successfully"}
                variant={"success"}
                autoHide={Constants.SnackBarCloseTimer}
                title={"Success"}
                handleClose={() => setShowSuccessSnackbar(false)}
            />

            <Modal show={show} onHide={handleClose} dialogClassName="bhb" enforceFocus={false}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        <img
                            src={logo}
                            height="40pt"
                            width="40pt"
                            alt={Constants.COMPANY_SITE}
                        />
                        &nbsp;&nbsp;Stone Media &nbsp;
                        <ShareIcon sx={{ cursor: "pointer" }} onClick={() => {
                            setShowSuccessSnackbar(true)
                            navigator.clipboard.writeText(stoneMediaURL);
                        }} />
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <iframe
                        src={stoneMediaURL + "?timestamp=" + Date.now()}
                        title="Stone Media"
                        width={"100% !important"}
                        height={"680px !important"}
                    ></iframe>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="contained" color="error" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal >
        </>
    );
};

export default StoneMediaModal;
